<template lang="pug">
.ticket-module(v-if="data||loading" :class="['length-'+(data||[]).length]")
  .scroll-container
    template(v-if="loading")
      .shadow.ticket-wrapper
      .shadow.ticket-wrapper
    template(v-else)
      template(v-for="item in data")
        .ticket-wrapper
          Coupon(:info="item", @click="clickTicket(item)", :active="true")
      ComingSoon.coupon-holder(v-if="data.length === 1", :active="true")
      .placeholder(v-if="data.length>2") &nbsp;
</template>

<script>
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import { ParamsUtil } from '../../../utils/params';
import ComingSoon from './coming-soon';
import Coupon from './coupon';
import { getTokenAndLocation } from '../../../utils';

export default {
  components: {
    Coupon,
    ComingSoon,
  },
  props: {
    data: {
      type: Array,
      default: null,
    },
    loading: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      more: false,
    };
  },
  methods: {
    async clickTicket(item) {
      if (item) {
        UBT.clickButton({
          pageId: 'APP_exclusive',
          buttonName: 'APP_bikecoupon',
          categoryId: 'platform',
          businessInfo: {
            commodity_name: item.name,
            business: item.businessType,
          },
        });
        if (item.url) {
          const { token, adCode, cityCode } = await getTokenAndLocation();
          window.location.href = ParamsUtil.addParams(item.url, { token, adCode, cityCode });
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
.ticket-module {
  height: 1.58rem;
  box-sizing: border-box;

  .coupon-holder {
    margin-left: 0.16rem;
  }

  .scroll-container {
    display: flex;
    padding: 0.2rem 0.12rem 0.16rem;
    overflow-x: scroll;

    &::-webkit-scrollbar {
      display: none;
      width: 0;
      height: 0;
      color: transparent;
    }
  }

  .placeholder {
    width: 0.12rem;
    height: 100%;
  }

  .shadow {
    width: 1.46rem;
    height: 1.26rem;
    background: #f7f9fa;
    border-radius: 0.08rem;
  }

  .ticket-wrapper {
    &:not(:last-of-type) {
      margin-right: 0.08rem;
    }
  }

  &.length-2 {
    .ticket-wrapper {
      &:not(:last-of-type) {
        margin-right: 0.24rem;
      }
    }
  }
}
</style>
